import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getCouponById } from "../../api/couponService";

export default function ViewCoupon() {
  const location = useLocation();
  const id = location?.state?.couponId;

  const [coupon, setCoupon] = useState(null);

  //FIXED DATE FORMAT (DD/MM/YYYY)
  const formatDate = (dateStr) => {
    if (!dateStr) return "-";

    const date = new Date(dateStr);

    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = date.getFullYear();

    return `${dd}/${mm}/${yyyy}`;
  };

  useEffect(() => {
    const load = async () => {
      try {
        const res = await getCouponById(id);


        setCoupon(res?.data || res);
      } catch (err) {

      }
    };

    load();
  }, [id]);

  if (!coupon) return <h5>Loading...</h5>;

  return (
    <div className="container-fluid p-4">
      <div className="card p-3">
        <h5 className="mb-3">View Coupon</h5>

        <div className="row g-3">
          {/* TITLE FIRST */}
          <div className="col-md-4">
            <span className="fw-bold">Title : </span>
            {coupon.title || "N/A"}
          </div>

          {/* CODE SECOND */}
          <div className="col-md-4">
            <span className="fw-bold">Coupon Code : </span>
            {coupon.code || "N/A"}
          </div>

          <div className="col-md-4">
            <span className="fw-bold">Discount Type : </span>
            {coupon.discountType || "N/A"}
          </div>

          <div className="col-md-4">
            <span className="fw-bold">Discount Value : </span>
            {coupon.discountValue || 0}
          </div>

          <div className="col-md-4">
            <span className="fw-bold">Min Order : </span>₹
            {coupon.minOrderAmount || 0}
          </div>
          <div className="col-md-4">
            <span className="fw-bold">Max Order : </span>₹
            {coupon.minOrderAmount || 0}
          </div>

          <div className="col-md-4">
            <span className="fw-bold">Max Discount : </span>₹
            {coupon.maxDiscount || 0}
          </div>

          {/* FIXED DATE FORMAT HERE */}
          <div className="col-md-4">
            <span className="fw-bold">Expiry Date : </span>
            {formatDate(coupon.expiryDate)}
          </div>

           <div className="col-md-4">
            <span className="fw-bold"> Start Date : </span>
            {formatDate(coupon.expiryDate)}
          </div>

           <div className="col-md-4">
            <span className="fw-bold">Applicable Product: </span>
            {coupon.usageLimit || 0}
          </div>

            <div className="col-md-4">
            <span className="fw-bold">Applicable Category: </span>
            {coupon.usageLimit || 0}
          </div>

            <div className="col-md-4">
            <span className="fw-bold">Total User Usage Limit: </span>
            {coupon.usageLimit || 0}
          </div>


          <div className="col-md-4">
            <span className="fw-bold">Usage Limit : </span>
            {coupon.usageLimit || 0}
          </div>

          <div className="col-md-4">
            <span className="fw-bold">Status : </span>
            <span
              className={`badge ${
                coupon.status === "ACTIVE" ? "bg-success" : "bg-danger"
              }`}
            >
              {coupon.status || "Inactive"}
            </span>
          </div>

          <div className="col-md-12">
            <span className="fw-bold">Description : </span>
            {coupon.description || "N/A"}
          </div>
        </div>
      </div>
    </div>
  );
}
